import React from 'react';
import { motion } from 'framer-motion';
import { ListTodo, Plane, Clock, Smartphone } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: ListTodo,
    title: 'Hacer listas y usar agendas',
    description: 'Solo organiza el caos, pero no elimina la carga mental que te está quemando.'
  }, {
    icon: Plane,
    title: 'Tomar vacaciones',
    description: 'El agotamiento te sigue en la maleta y el primer email al volver borra cualquier rastro de paz.'
  }, {
    icon: Clock,
    title: "Esperar a que 'las cosas se calmen'",
    description: 'Nunca se calman porque tú has enseñado a los demás que tú siempre puedes con todo.'
  }, {
    icon: Smartphone,
    title: 'Automedicarte con redes sociales',
    description: "El 'scroll' infinito no es descanso, es solo una fuga mental que te deja más vacía."
  }];
  return <section className="space-y-12" data-id="element-70">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6
    }} className="space-y-6" data-id="element-71">
        <h2 className="text-3xl md:text-4xl font-bold text-[#3D2B1F] text-center" data-id="element-72">
          Tu cerebro tiene{' '}
          <span className="text-[#C4704B] underline decoration-[#C4704B]/30 decoration-2 underline-offset-4" data-id="element-73">
            40 pestañas abiertas
          </span>
        </h2>

        <div className="prose prose-lg prose-p:text-[#3D2B1F]/90 max-w-2xl mx-auto leading-relaxed" data-id="element-74">
          <p data-id="element-75">
            Vives en un estado de alerta constante. La logística del hogar, los
            problemas en el trabajo, el bienestar de tu pareja, el recordatorio
            de esa cita médica y la culpa por no haber hecho "suficiente".
          </p>
          <p data-id="element-76">
            Te has convertido en la <strong data-id="element-77">"Resolvedora Profesional"</strong>{' '}
            de todos. Eres el pilar que sostiene el mundo de los demás, pero
            mientras todos descansan sobre ti, tú no tienes dónde apoyarte. El
            resultado no es solo cansancio físico; es un vacío emocional que te
            hace sentir invisible en tu propia casa.
          </p>
        </div>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-78">
        {problems.map((item, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="bg-white p-6 rounded-2xl shadow-[0_4px_20px_-4px_rgba(61,43,31,0.05)] border border-[#3D2B1F]/5 hover:border-[#C4704B]/20 transition-colors" data-id="element-79">
            <div className="flex items-start space-x-4" data-id="element-80">
              <div className="bg-[#FDF8F3] p-3 rounded-full text-[#C4704B]" data-id="element-81">
                <item.icon className="w-6 h-6" data-id="element-82" />
              </div>
              <div data-id="element-83">
                <h3 className="font-bold text-[#3D2B1F] text-lg mb-2" data-id="element-84">
                  {item.title}
                </h3>
                <p className="text-[#3D2B1F]/80 text-sm leading-relaxed" data-id="element-85">
                  {item.description}
                </p>
              </div>
            </div>
          </motion.div>)}
      </div>
    </section>;
}